<template>
    <!-- ADD THE :key HERE -->
    <div class="" :key="$i18n.locale">
        <RoleEvaluationModal ref="roleEvalModal" />
        <EvaluationCriteriaModal ref="evalCriteriaModal" />

        <div id="organisationChartBody" class="organisationChartBody" ref="organiGramBox"></div>
    </div>
</template>

<script>

import constants from "@/constants";
import { OrganiGram } from "./OrganiGram/src/organi-gram";
import { app } from "./OrganiGram/src/feathers-socketio";
import { kvdrOrgConfig } from "@/assets/data/kvdrOrgConfigs.js";
import skills from "@/assets/data/all-skills.js";
import softSkills from "@/assets/data/all-personality.js";
import fallbackLogo from '@/assets/images/icons/organization/business_black_36dp.svg';
import RoleEvaluationModal from './OrganiGram/src/RoleEvaluationModal.vue';
import EvaluationCriteriaModal from './OrganiGram/src/EvaluationCriteriaModal.vue';

export default {
    props: {
        // FIXED: Accept Array OR Object to prevent Prop validation warnings if parent passes null
        'importData': [Array, Object]
    },
    name: 'OrganiGram',
    components: {
        RoleEvaluationModal,
        EvaluationCriteriaModal 
    },
    data() {
        return {
            chartObject: null,
            candidateList: [], // Initialize as empty array
            dataCollection: '',
            selectedLegends: 12,
            colorsFromKey: {
                0: "#FF6347",
                1: "#0BA5EC",
                2: "#7A5AF8",
                3: "#12B76A",
                4: "#FB6514",
                5: "#4E5BA6",
                6: "#F2C046",
                7: "#EE46BC",
                8: "#F36677",
                9: "#808000",
                10: "#FF69B4",
                11: "#C6211B",
                12: "#A52A2A",
                13: "#008080",
                14: "#708090",
            },
            kvdrId: '',
        }
    },
    computed: {
        avatarNameGenerator() {
            return this.$store.state.users.avatarNameGenerator;
        },
        userId() {
            return this.$store.state.auth.user._id;
        },
        orgData() {
            return this.$store.state.organization.orgData || {};
        },
        kvdrData() {
            return this.$store.state.kvdr.selectedKVDR;
        },
        employeesData() {
            // ROBUST FIX: Explicitly check if it is an array. 
            // If store returns null, undefined, or an Object, return [].
            const data = this.$store.state.organization.employees;
            return Array.isArray(data) ? data : [];
        },
        userData() {
            // ROBUST FIX: employeesData is guaranteed to be an array now.
            // We also guard against the .find() result being undefined.
            const foundUser = this.employeesData.find(e => e.userId == this.userId);
            
            if (foundUser && foundUser.userData) {
                return { ...foundUser.userData, _id: this.userId };
            }

            // Return a safe fallback object so the chart library doesn't crash reading properties
            return { 
                _id: this.userId, 
                firstName: 'Unknown', 
                lastName: 'User',
                email: '' 
            };
        }
    },
    watch: {
        selectedLegends(newVal) {
            this.createData(newVal);
            this.renderChart(this.dataCollection);
        },
        '$i18n.locale'(newLocale) {
            if (this.dataCollection) {
                this.renderChart(this.dataCollection);
            }
        },
        orgData: {
            deep: true,
            handler(newVal) {
                if (newVal && newVal._id) {
                    this.setKVDRState();
                }
            },
        },
        employeesData(newVal) {
            // Only trigger if data exists and org is loaded
            if (Array.isArray(newVal) && this.orgData && this.orgData._id) {
                this.setKVDRState();
            }
        }
    },
    methods: {
        openEvaluationCriteriaModal(orgId, roleId, userId) {
      if (this.$refs.evalCriteriaModal) {
        this.$refs.evalCriteriaModal.openModal(orgId, roleId, userId);
      } else {
        console.error("EvaluationCriteriaModal ref not found!");
      }
    },
        openVueRoleModal(event) {
            console.log("🟢 KVDR.vue has received the event!", event.detail);
            if (this.$refs.roleEvalModal) {
                this.$refs.roleEvalModal.open(event.detail);
            } else {
                console.error("🔴 CRITICAL: Modal reference is not found in KVDR.vue!");
            }
        },
        renderChart(data) {
            // Safety check: ensure container exists before rendering
            if (!this.$refs.organiGramBox && !document.getElementById('organisationChartBody')) return;

            // Ensure we have a valid org ID before starting
            if (!this.orgData._id) return;

            this.chartObject = new OrganiGram('abc123def456', 'KVDR', this);
            this.chartObject.container('organisationChartBody')
                            .id(this.kvdrId)
                            .root({
                                id: this.orgData._id,
                                name: this.orgData.name || 'Organization',
                                image: (this.orgData.logo) ? constants.s3Bucket + '/organization/logo/'+ this.orgData.logo : fallbackLogo })
                            .type('F')
                            .data(data)
                            .candidateList(this.candidateList || []) // Ensure this is never null
                            .user(this.userData)
                            .skills(skills)
                            .softSkills(softSkills)
                            .displaySettings({
                                cardColor : this.orgData.primaryThemeColor || '#000000',
                                textColor : '#'+(this.orgData.secondaryThemeColor || 'ffffff'),
                                borderColor: 'rgba(250,250,0,0.1)'
                            })
                            .onNodeClick((d)=>{
                                const _id = this.kvdrId;
                                let graphData = {...d,kvdrId:_id}
                                return app.service('kvdr-role').create(graphData)
                                .then(res => {
                                    this.$vs.notify({
                                        title: 'Create',
                                        text: 'Role Created successfully',
                                        color: '#008000'
                                    });
                                    return res;
                                })
                                .catch(err => {throw err});
                            })
                            .onNodeDelClick (d => {
                                app.service('kvdr-role').remove(null, {
                                    query: { selfId: d }
                                })
                                .then(res => {
                                    this.$vs.notify({
                                        title: 'Delete',
                                        text: 'Role deleted successfully',
                                        color: '#008000'
                                    })
                                })
                                .catch(err => {throw err});
                            }).
                            onNodeAddProfileClick( d => {
                                const roleProfileAPIData = {
                                    kvdrRoleId : d.roleId,
                                    userId : d.userId
                                }
                                return this.$store.dispatch('kvdr/createKvdrRoleProfile', roleProfileAPIData)
                                .then(res => {
                                    this.$vs.notify({
                                        title: 'Add Profile',
                                        text: 'Profile added successfully',
                                        color: '#008000'
                                    });
                                    return res;
                                })
                                .catch(err => {throw err});
                            }).
                            onNodeRemoveProfileClick(d=>{
                                this.$store.dispatch('kvdr/deleteKvdrRoleProfile', d)
                                .then(res => {
                                    this.$vs.notify({
                                        title: 'Remove Profile',
                                        text: 'Profile removed successfully',
                                        color: '#008000'
                                    })
                                })
                                .catch(err => {throw err;});
                            }).
                            onNodeFetch(d=>{
                                return this.$store.dispatch('kvdr/findKvdrRole',d)
                                .then(res=>{ 
                                    return res.data;
                                })
                                .catch(err => { return err })  
                            }).
                            onNodeUpdate(d=>{
                                app.service('kvdr-role').patch(null,
                                    d.data, { query: { selfId: d.query } }
                                )
                                .then(res => {
                                    this.$vs.notify({
                                        title: 'Role Update',
                                        text: 'Updated successfully',
                                        color: '#008000'
                                    })
                                })
                                .catch(err => {throw err;});
                            }).
                            onNodeProfileFetch(d=>{
                                return this.$store.dispatch('kvdr/findKvdrRoleProfile',d)
                                .then(res=>{ 
                                    return res.data;
                                })
                                .catch(err => { return err })  
                            }).
                            onNodeProfileUpdate(d=>{
                                return this.$store.dispatch('kvdr/patchKvdrRoleProfile',d)
                                .then(res=>{
                                    this.$vs.notify({
                                        title: 'Profile Update',
                                        text: 'Profile updated successfully',
                                        color: '#008000'
                                    })
                                    return res[0];
                                })
                                .catch(err => { return err })    
                            }).render();
        },
        createData(chartData) {
            // Guard against null chartData
            if (!chartData || !this.orgData._id) return {};

            // Safe candidate mapping
            if(this.employeesData.length){
                this.candidateList = this.employeesData.map(m =>  
                ({
                    id: m.userId,
                    name: (m.userData.firstName || '') + ' ' + (m.userData.lastName || ''),
                    imageUrl: (m.userData.profilePictureUrl) ? `${constants.s3Bucket}/editor/profile-pictures/${m.userData.profilePictureUrl}` : `https://hostedboringavatars.vercel.app/api/beam?name=${m.userData.firstName || 'User'}`,
                    emailId: m.userData.email,
                }))
            }
            else {
                this.candidateList = [];
            }

            let dataCollection = 
            ({
                id : chartData._id,
                name : chartData.title,
                version : chartData.version,
                kvdrOrgConfigData : kvdrOrgConfig(this.orgData._id),
                // Safety check on kvdrRoles
                graphData : (chartData.kvdrRoles && Array.isArray(chartData.kvdrRoles)) ? chartData.kvdrRoles.map(m =>  
                ({
                    ...m,
                    profiles : (m.kvdrRoleProfiles && Array.isArray(m.kvdrRoleProfiles)) ? m.kvdrRoleProfiles.map(p => ({
                        userId : p.userId,
                        assessmentData : {'Fitment (Fit)':p.fitmentData,'Performance (Drive)':p.performanceData,'Succession (Secure)':p.successionData,'Appraisal':p.appraisalData}
                    })) : [],
                })) : [],
            });

            return dataCollection;
        },
        setKVDRState() {
            // Double check orgData exists before call
            if(!this.orgData || !this.orgData._id) return;

            this.$store
                .dispatch("kvdr/findKVDR", this.orgData._id).
                then(res => {
                    if (!res || !res.data || !res.data.length) {
                        let data = {
                            userId: this.userId,
                            orgId: this.orgData._id,
                        }
                        this.$store.dispatch("kvdr/createKVDR", data).
                            then(res => {
                                this.kvdrId = res._id;
                                this.dataCollection = this.createData(res);
                                this.renderChart(this.dataCollection);
                            })
                            .catch((err) => {
                                console.error("Error creating KVDR", err);
                            })
                    }
                    else {
                        this.kvdrId = res.data[0]._id;
                        this.dataCollection = this.createData(res.data[0]);
                        this.renderChart(this.dataCollection);
                    }
                })
                .catch((err) => {
                    console.error("Error finding KVDR", err);
                });
        }
    },
     mounted (){
        // 5. Add the listener here
        window.addEventListener('open-vue-role-modal', this.openVueRoleModal);
        
        if (this.orgData && this.orgData._id) {
            this.setKVDRState();
        }
    },
    beforeDestroy() {
        // 6. Clean up the listener
        window.removeEventListener('open-vue-role-modal', this.openVueRoleModal);
    }
}
</script>

<style scoped>
#organisationChartBody {
    /* height: 61vh; */
    border-top: 1px solid #f1f5f9;
}

@import './OrganiGram/public/css/app.css';
</style>